<template lang='pug'>
.itlp-checkout-timer(v-if='wooCart.cart.value?.extensions?.itlp?.quotation_expire_at')
	div.itlp-checkout-timer-main-container
		span {{i18n.__('Tempo rimanente', 'italpreziosi')}}
		span {{ wooCart.expirationCountdown.value.minutes }} min : {{wooCart.expirationCountdown.value.seconds}} sec
		span {{i18n.__('per mantenere questo prezzo di acquisto.', 'italpreziosi')}}
	div.itlp-checkout-timer-bar-container
		div.itlp-checkout-timer-bar(:style="{width: wooCart.expirationPercentage.value + '%'}")
</template>

<script setup lang="ts">
import {i18n} from "@/libs/wordpress.facade";
import useCheckout from '../composables/useCheckout';

const {step, wooCart} = useCheckout();
</script>
